'use client';

import { Clock, ClockContainer,Hours, Minutes } from './styles';

export function ClockLoader() {
  return (
    <ClockContainer>
      <Clock>
        <Minutes />
        <Hours />
      </Clock>
    </ClockContainer>
  );
}